<script lang="ts">
    import {onMount} from "svelte";
    import {AuthStore} from "../../store/AuthStore";
    import LoginView from "../../component/auth/LoginView.svelte";

    $: authStoreAuthStatus = AuthStore.authStatus;
    $: authStoreAuthUser = AuthStore.user;

    export let component;
    export let params = {};

    export let isAdminOnly = false;

    $: canAccess = (() => {
        if ($authStoreAuthUser == null) {
            return false;
        }
        if (isAdminOnly) {
            if ($authStoreAuthUser.is_admin !== true) {
                return false;
            }
        }
        return true;
    })();

    onMount(() => {
    });


</script>

{#if $authStoreAuthStatus === AuthStore.AuthStatusType.authorized}

    {#if canAccess}
        <svelte:component this={component} params={params}/>
    {:else}
        <div class="invalid-access">
            アクセスできません
        </div>
    {/if}

{:else if $authStoreAuthStatus === AuthStore.AuthStatusType.unAuthorized}
    <div class="login-area">
        <LoginView/>

    </div>


{:else}
    <div>
        <!--            ログイン状態確認中-->
    </div>
{/if}
<style>
    .invalid-access {
        padding: 5em;
    }

    .login-area {
    }


</style>


